/**
 * Runs a request that has to succeed before a form submit can continue — the
 * paywall lookups the create-project and create-task submits do before their
 * mutation.
 *
 * Those lookups used to abort the submit silently on failure: offline, the
 * Create button did nothing at all and only ERR_INTERNET_DISCONNECTED showed
 * up in the console. The failure is now reported through `onError` and
 * rethrown, so the submit promise rejects — which is what lets the bottom
 * sheets skip their success-only cleanup and keep the user's input for a
 * retry (see `runTaskCreateSubmit` / `runProjectCreateSubmit`).
 */
export const runSubmitPreflight = async <T>(
  request: () => Promise<T>,
  onError: (error: unknown) => void
): Promise<T> => {
  try {
    return await request();
  } catch (error) {
    onError(error);
    throw error;
  }
};
